import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * React Query state key for fetch BIDDING WINDOWS BY VALIDITY CONFIG api.
 */
const FETCH_BIDDING_WINDOWS_BY_VALIDITY_CONFIG_QUERY_KEY =
  'fetch-bidding-windows-by-validity-config-query-key';

/**
 * React Query hook for bidding windows by bid validity configuration api
 * management.
 */
export const useBiddingWindowsByValidityConfigQuery = (
  bidValidityConfigId: string | null
) => {
  const { data, error, isError, isPending, isFetching, refetch } =
    useQueryWithUserId({
      queryKey: [
        FETCH_BIDDING_WINDOWS_BY_VALIDITY_CONFIG_QUERY_KEY,
        bidValidityConfigId,
      ],
      queryFn: () => {
        if (!bidValidityConfigId) {
          return Promise.resolve([]);
        }

        return BIDS_API.fetchBiddingWindowsByValidityConfig(
          bidValidityConfigId
        );
      },
      enabled: !!bidValidityConfigId,
      retry: false,
    });

  return {
    data: data ?? [],
    error,
    isError,
    isPending,
    isFetching,
    refetch,
  };
};
